export default __webpack_public_path__ + "static/media/unable-to-connect-to-the-server.607c62c8.svg";